import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { contentBankApi } from "../../../utils";
import closeIcon from '../../../assests/directLesson/go-back--dark-icon.png'
import IdeRunner from "../../lms-shared/IdeRunnerWarrper/IdeRunner";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import * as PathRouter from '../../../models/PathRoute'
import classes from './DirectLessonProject.module.css'

const DirectLessonProject = () => {

    const [data, setData] = useState()
    const dispatch = useDispatch();
    const { postId } = useParams()
    const { texts, lang } = useSelector(state => state.translate);
    const homeUrl = useSelector((state) => state.application.homeUrl);

    useEffect(() => {
        if (lang) {
            contentBankApi.contentBankFilterIdPost(postId, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.projectsFilterIdError, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 2, component: "Project", line: 58 }))
                } else {
                    if (resdata) {
                        let contentData = JSON.parse(resdata.contentData)
                        setData({
                            ideUrl: contentData.Ide.Url,
                            assessmentName: resdata.name,
                            ideLang: contentData.Ide.Lang || lang,
                            ideConfig: JSON.parse(contentData.Ide.AdditionalConfiguration),
                            fileUrl: resdata.url,
                            share: false,
                            author: `${resdata.user?.firstName} ${resdata.user?.lastName}`,
                        });
                    }
                }
            })
        }
    }, [lang])

    function close() {
        window.location.href = `${window.location.origin}${process.env.PUBLIC_URL}${homeUrl}/${PathRouter.MATERIAL_LIBRARY}`
    }

    return (
        data ? <div className={classes.LessonProjectContainer}>
            <div className={classes.Header}>
                <p>{data.assessmentName}</p>
                <button className={classes.CloseIcon} onClick={close}> <img src={closeIcon} className={classes.Icon} alt="CloseIcon" /></button >
            </div>
            <IdeRunner projectData={data} />
        </div> : ''
    )
}

export default DirectLessonProject;